/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Field, FieldArray, Form, Formik } from 'formik';
import Icon from 'components/Icon';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Layout, DateRangePicker, NotesModal } from 'components';
import { Col, Row } from 'components/Grid';
import Loader from 'components/Loader';
import { GridColumnTitle, InputField, Label, SelectField, } from 'components/Form';
import DialogComponent from "components/Dialog";
import { FitinsurAPI, MessageCenter } from 'utils';
import IMask from 'imask';
import {
  FieldGrid,
  ColIcon,
  TableHeader,
  TableCollum,
  CalendarContainer,
  Content,
  ContentTextarea,
  CustomField,
  DialogCancel,
  DialogConfirm,
  InlineLabel,
  LoadContainer,
  FilterContainer,
  MobileLabel,
  RowFilterOrder,
  DialogIcon,
  TableHead,
  TableRow,
  TableBody,
  Table,
  RowFilterIcon,
  FilterSearchContainer,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  Counter,
  FilterLabel,
  TooltipCard,
  TooltipText,
  TooltipBox,
  TotalAmount,
  TotalAmountMini,
  TitleTotalAmount,
  VerticalLine,
  CounterAmount,
} from './styles';
import { Button } from 'components/index';
import ButtonImportOSND from './ButtonImportOsnd';
import Checkbox from 'components/Form/CheckBox';
import Checkbox2 from 'components/Form/CheckBox2';
import HasPermission from 'components/HasPermission/index';
import MultiSelectField from 'components/Form/MultiSelectField';
import BulkPaymentUpdate from './BulkPaymentUpdate';
import CacheManager from 'utils/src/cache-manager';
import MultipleExport from './MultipleExport'
import { ResponsiveTable } from '@fitinsur/components';
import ListEnquiryButtons from 'components/ListEnquiryButtons';
import useWindowScroll from 'services/useWindowScroll';
import Access from 'constants/Access';
import MasksHelper from 'utils/src/masks';

const columnsFilter = [
  {
    title: "DEAL",
    value: "deal",
    minWidth: 180
  },
  {
    title: "CLIENT",
    value: "client",

  },
  {
    title: "MAIN PARTY",
    value: "party",
  },
  {
    title: "OFFICE",
    value: "office",
  },
  {
    title: "DOC",
  },
  {
    title: "AMOUNT",
    value: "amount",
  },
  {
    title: "DUE DATE",
    value: "dueDate",
  },
  {
    title: "IDENTIFIER",
  },
  {
    title: "INVOICE SENT",
  },
  {
    title: "STATUS",
  },
  {
    title: "ACTION",
    key: 'actions'
  },
];

const handleColorLabel = (item) => {
  if (item.isRejected) return Colors.GRAY[3];
  else if (item.requireAttention) return Colors.RED;
  else if (item.isApproved) return Colors.GRAY[0];
  else if (item.mediationFinished) return Colors.PRIMARY1;
  else return Colors.GRAY[0];
}

export default function PaymentPage(props) {
  const cache = new CacheManager();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();
  const location = useLocation();
  const formik = useRef();
  const [sortBy, setSortBy] = useState(
    {
      key: null,
      direction: null,
    }
  );

  const [scrollUpdateMode, setScrollUpdateMode] = useState(false);
  let scrollUpdate = useWindowScroll();  

  const maskHelper = new MasksHelper();
  const [masks, setMasks] = useState([]);
  const [sumAmount, setSumAmount] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showInvoiceSentCalendar, setShowInvoiceSentCalendar] = useState(false);
  const [showPaymentNotesModal, setShowPaymentNotesModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [offices, setOffices] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [notesModalProps, setNotesModalProps] = useState(null);
  const [selectedPaymentsUpdate, setSelectedPaymentsUpdate] = useState([]);
  const [selectedPaymentsIndex, setSelectedPaymentsIndex] = useState([]);
  const [modalOptions, setModalOptions] = useState([]);
  const [dealGroup, setDealGroup] = useState(null);
  const [modal, setModal] = useState(false);
  const [filtersList, setFiltersList] = useState([]);
  const [isAbleEdit, setIsAbleEdit] = useState(false);
  const [isAbleDelete, setIsAbleDelete] = useState(false);
  const [isAbleCreate, setIsAbleCreate] = useState(false);
  const [typeDialog, setTypeDialog] = useState(null);
  const [filterOptions, setFilterOptions] = useState([]);
  const [tooltips, setTooltips] = useState([]);
  const [products, setProducts] = useState(
    [
      {
        label: "NO PRODUCTS",
        value: ""
      }
    ]
  );
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
    type: ""
  });
    

  let divSize = { width: 0, height: 0 };
  const region = authContext.region === 'en-GB' ? 'en' : 'en';

  const handleDivSize = () => {
    const divElement = document.getElementById('tableColumnDimensions');
    if (divElement) {
      const rect = divElement.getBoundingClientRect();
      divSize = { width: rect.width, height: rect.height };
    }
  };

  const initialValues = {
    filter: {
      id: "",
      name: "",
      deal: "",
      office: "",
      client: "",
      doc: "",
      party: "",
      currency: "",
      dueDate: {
        from: null,
        to: null,
      },
      status: "",
      identifier: "",
      invoiceSent: {
        from: null,
        to: null,
      },
      hideAbortedTransactions: false,
      hideDirectPayment: false,
      hidePaidPayment: false
    },
    payments: data
  };

  const [filterSelected, setFilterSelected] = useState(initialValues);

  const getStatusFilter = [
    { label: 'Created', value: 'Created' },
    { label: 'Awaiting Payment', value: 'awaiting_payment' },
    { label: 'Paid', value: 'paid' },
    { label: 'Sent to XIS', value: 'loaded' },
    { label: 'Signed', value: 'assigned' },
    { label: 'Aborted', value: 'aborted' }
  ];

  const columns = [
    {
      title: "REFERENCE",
      key: "deal",
      sortKey: "deal",
      minWidth: 24,
      maxWidth: 24,
      color: (item) => handleColorLabel(item),
      component: (item, index) =>
        <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
          <HasPermission permission={props.permissions.PAYMENTS_CHANGE_STATUS || !props.permissions.PAYMENTS_CHANGE_ABORTED}>
            <Checkbox2
              checked={selectedPaymentsIndex.includes(index)}
              onClick={(e) => handlePaymentSelectionToUpdateStatus(index, e)}
            />
          </HasPermission>

          <DialogIcon pink={'exclamation'} style={{ width: 5, marginBottom: -5, marginLeft: 5 }}>
            {item.isOverDue && item.status.label !== "Paid" && item.status.label !== "Aborted" ? "!" : ""}
          </DialogIcon>

          <Label wordWrap fontSize={13}>
            {item.deal}
          </Label>
        </div>
    },
    {
      title: "CLIENT",
      key: "client",
      sortKey: "client",
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "MAIN PARTY",
      key: "party",
      sortKey: "party",
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "OFFICE",
      key: "office",
      sortKey: "office",
      minWidth: 12,
      maxWidth: 12,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "DOC",
      key: "doc",
      sortKey: "doc",
      minWidth: 12,
      maxWidth: 12,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "AMOUNT",
      key: "amount",
      sortKey: "amount",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (item, index) => <Label style={item.amount.amountType === "D" ? { color: "red" } : { color: "black" }} wordWrap fontSize={13}>
        {item.amount.currency}
        <br />
        {item.amount.amount}
      </Label>
    },
    {
      title: "DUE DATE",
      key: "dueDate",
      sortKey: "dueDate",
      minWidth: 13,
      maxWidth: 13,
      color: (item) => handleColorLabel(item),
      component: (item, index) =>
        <Label wordWrap fontSize={12}>
          {new Date(item.dueDate).toLocaleDateString('en-GB', { timeZone: 'UTC' })}
        </Label>
    },
    {
      title: "IDENTIFIER",
      key: "osnd",
      minWidth: 12,
      maxWidth: 12,
      color: (item) => handleColorLabel(item),
      component: (item, index) => <Field
        name={`payments.${index}.identifierOSND`}
        onChange={(e) => formik.current?.setFieldValue(`payments.${index}.identifierOSND`, e)}
        component={InputField}
        validation={false}
        disabled={!props.permissions.PAYMENTS_CHANGE_STATUS || (!props.permissions.PAYMENTS_CHANGE_ABORTED && item.status.label === "Aborted") || (item.status.label === "Paid" || item.status.label === "Aborted" || item.status.label === "Direct Payment")}
      />
    },
    {
      title: "INVOICE SENT",
      key: "dateSentExternalPaymentPack",
      sortKey: "invoiceSent",
      minWidth: 13,
      maxWidth: 13,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "STATUS",
      key: "status",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (item, index) => <Field
        onChange={() => {
          setTypeDialog('changeStatus')
          setDialog({
            visible: true,
            title: "CONFIRM STATUS",
            icon: "TimesCircle",
            type: "month",
            args: {
              index: index,
            },
          })
        }}
        name={`payments.${index}.status`}
        placeholder='Status'
        component={SelectField}
        options={getStatus(item.listStatus.status, item.status.label)}
        validation={false}
        disabled={!props.permissions.PAYMENTS_CHANGE_STATUS || (!props.permissions.PAYMENTS_CHANGE_ABORTED && item.status.label === "Aborted") || (item.status.label === "Paid" || item.status.label === "Direct Payment")}
      />
    },
    {
      title: "ACTIONS",
      key: "actions",
      minWidth: 7,
      maxWidth: 7,
      color: (item) => handleColorLabel(item),
      paddingRight: 1,
      component: (item) => <div style={{ display: "flex", justifyContent: 'flex-end' }}>
        <TooltipCard style={{ marginRight: 5 }}>
          <TooltipText>
            <Icon
              name="folder"
              onClick={() => { history.push(`/broking/document-management/${item.idOperationReference || item.idOperation}`) }}
              style={{ alignSelf: "center", cursor: "pointer" }}
            />
          </TooltipText>
          <TooltipBox>
            {tooltips[588]}
          </TooltipBox>
        </TooltipCard>
        <TooltipCard>
          <TooltipText>
            <HasPermission permission={props.permissions.PAYMENTS_COMMENTS}>
              <Icon
                name="note-add"
                onClick={() => {
                  setShowPaymentNotesModal(true)
                  handleGetNotes(item)
                }}
                style={{ alignSelf: "center", cursor: "pointer" }}
              />
            </HasPermission>
          </TooltipText>
          <TooltipBox>
            {tooltips[587]}
          </TooltipBox>
        </TooltipCard>
      </div>
    },
  ];

  const goToLoginPage = () => history.push('/login');

  async function requestProductsList() {
    const response = await fitinsur
      .requestAccess("", "CREATE", Access.CREATE_FRAMEWORK, null, null, authContext.token)
      .then((response) => response.json())

    const hasPermission = response && response.ret_code === 200;

    fitinsur.requestProductsList()
      .then(x => x.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        const options = response.ret_value
          .map(product => ({
            label: product.PRODUCT_NAME,
            value: product.ID_PRODUCT
          }))
          .filter(product => {
            if (product.value === 16 && !hasPermission) {
              return;
            } else {
              return product;
            }
          })
        setProducts(options);
      })
      .catch(error => console.log(error));
  }

  const handleResettingPaymentSelection = () => {
    setDealGroup(null);
    setSumAmount(0);
    setSelectedPaymentsIndex([]);
    setSumAmount(0)
    setSelectedPaymentsUpdate([]);
  }

  const handleHighlightPayment = (selectedPaymentsIndex) => {
    setData(() => data.map((datum, index) => {
      datum.highlightPayment = selectedPaymentsIndex.includes(index);
      return datum;
    }))
  }

  const deleteFilter = () => {
    if (filterSelected.filterName) {
      setTypeDialog('deleteFilter')
      setDialog({
        visible: true,
        title: 'REMOVE FILTER',
        icon: 'exclamation',
        args: null,
        type: ""
      })
    }
  }

  const handleStatus = (index, resp) => {
    if (resp === "cancel") {
      formik.current?.setFieldValue(`payments[${index}].status`, data[index].status)
      setDialog({ visible: false, title: null, icon: null, args: null });
      return;
    }
    const installment = formik.current?.values.payments[index];
    const { identifierOSND, idInstallments, status } = installment;

    if (status.label.toLowerCase() === "paid") {
      if (!formik.current?.values.payments[index].identifierOSND && formik.current?.values.payments[index].LPAN) {
        mc.error("Please, insert IDENTIFIER/OSND reference");
        formik.current?.setFieldValue(`payments[${index}].status`, data[index].status);
        return;
      } else {
        handleUpdate([installment], status.id, index);
      };
    } else {
      handleUpdate([installment], status.id, index);
    }

    setDialog({ visible: false, title: null, icon: null, args: null, type: "" });
  };

  const handleUpdate = (selectedPayments, selectedStatus, updateIndex = null) => {
    loading.start();
    try {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestUpdateInstallments(selectedPayments, selectedStatus, true).then(
        response => response.json()).then(data => {
          if (data.ret_code !== 200) {
            mc.error(data.ret_msg_details);
            loading.stop();
            return;
          }

          if (updateIndex !== null && selectedPayments.length === 1) {
            const updatedStatus = selectedPayments[0].status;
            setData(prevData => prevData.map((v, i) => i === updateIndex ? { ...v, status: updatedStatus } : v));
          }

          loading.stop();
        }
        );
    } catch (error) {
      loading.stop();
      mc.error("An error happened, please try again.");
    }
  }

  const handleSubmitNotes = (item, notes) => {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateInstallmentsNotes(item.idInstallments, notes)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg);
          loading.stop();
          return;
        }
        handleGetNotes(item)
        loading.stop();
      })
      .catch(() => {
        loading.stop();
      });
  }

  const handleGetNotes = (item) => {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetInstallmentsNotes(item.idInstallments)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg);
          loading.stop();
          return;
        }
        setNotesModalProps({
          item,
          notes: data.ret_value
        })

        loading.stop();
      })
      .catch(() => {
        loading.stop();
      });
  }

  function resetFilters() {
    requestCustomFilterList('reset');
    formik.current.resetForm(initialValues);
    formik.current.values = initialValues;
    setPageNumber(1);
    setSortBy({
      key: null,
      direction: null,
    })
    handleFilter(initialValues.filter);
  };

  function handleSortList(key) {
    let direction = 'asc';
    if (sortBy.key === key && sortBy.direction === 'asc') {
      direction = 'desc';
    };
    const sort = { key: key, direction: direction }

    setSortBy(sort);
    setPageNumber(1);
    handleResettingPaymentSelection();
    getList(1, sort, `${location.search || '?'}`, true);
  };

  function nextPage() {
    if (pageNumber === totalPages) {
      return;
    }
    let contPage = (pageNumber + 1);
    setPageNumber(contPage);

    if (location.search) {
      getList(contPage, sortBy, location.search);
    } else {
      getList(contPage, sortBy)
    }
  };

  function getStatus(statusList, isAborted) {

    if (isAborted === 'Aborted') {
      statusList = statusList.filter(status => (status.label === 'Aborted' || status.label === 'Created'))
    }

    return !statusList ? [{}] :
      statusList?.map(item => {
        return {
          label: item.label,
          value: { id: item.idDomainStatus, label: item.label },
        }
      });
  };

  const jsonToQueryString = (json) => {
    const keys = Object.keys(json).filter(key => json[key]);

    return keys
      .map((key, index) => {
        const sufix = index + 1 === keys.length
          ? ''
          : '&'

        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) + sufix;
      }
      ).join('');
  }

  const handleFilter = (filters) => {
    const formikFilters = formik.current.values.filter;
    const { dueDate, invoiceSent, ...rest } = formikFilters;

    let dueDateRange = {};
    if (formikFilters.dueDate.from && formikFilters.dueDate.to) {
      dueDateRange = {
        dueDateFrom: new Date(formikFilters.dueDate.from).toLocaleDateString('en-US'),
        dueDateTo: new Date(formikFilters.dueDate.to).toLocaleDateString('en-US'),
      }
    } else if (filters.dueDateFrom && filters.dueDateTo) {
      dueDateRange = {
        dueDateFrom: new Date(filters.dueDateFrom).toLocaleDateString('en-US'),
        dueDateTo: new Date(filters.dueDateTo).toLocaleDateString('en-US'),
      }

      delete filters.dueDateFrom;
      delete filters.dueDateTo;
    }

    let invoiceSentRange = {};

    if (formikFilters.invoiceSent.from && formikFilters.invoiceSent.to) {
      invoiceSentRange = {
        invoiceSentFrom: new Date(formikFilters.invoiceSent.from).toLocaleDateString('en-US'),
        invoiceSentTo: new Date(formikFilters.invoiceSent.to).toLocaleDateString('en-US'),
      }
    } else if (filters.invoiceSentFrom && filters.invoiceSentTo) {
      invoiceSentRange = {
        invoiceSentFrom: new Date(filters.invoiceSentFrom).toLocaleDateString('en-US'),
        invoiceSentTo: new Date(filters.invoiceSentTo).toLocaleDateString('en-US'),
      }

      delete filters.invoiceSentFrom;
      delete filters.invoiceSentTo;
    }

    const newRest = {
      ...rest,
      deal: rest.deal.trim(),
      client: rest?.client.trim(),
      doc: rest?.doc.trim(),
      party: rest?.party.trim(),
      identifier: rest?.identifier.trim()
    }

    if (filters?.dueDate) {
      dueDateRange = {}
      delete filters.dueDate
    }

    if (filters?.invoiceSent) {
      invoiceSentRange = {}
      delete filters.invoiceSent
    }

    const filterObject = {
      ...newRest,
      ...dueDateRange,
      ...invoiceSentRange,
    }

    const orderObject = { ...filters };
    delete orderObject.payments;
    delete orderObject.undefined;
    delete orderObject.filter;

    let sortObj;
    for (let [key, value] of Object.entries(orderObject)) {
      if (!value) continue;

      let direction = 'asc';
      if (sortBy.key === key && sortBy.direction === 'asc') {
        direction = 'desc';
      };
      sortObj = { key: key, direction: direction }
      setSortBy(() => sortObj);
      break;
    }

    const queryString = jsonToQueryString(filterObject);
    const filterQueryString = `?${queryString}`;

    setPageNumber(1);
    handleResettingPaymentSelection();

    getList(1, sortObj ?? {}, filterQueryString, true);

    if (queryString) {
      localStorage.setItem('payment_filter', filterQueryString);
    } else {
      localStorage.removeItem('payment_filter');
    }

    history.push(`payments${filterQueryString}`);
  }

  const handleGetPreviusFilter = () => {
    const filterQueryString = localStorage.getItem('payment_filter');

    if (filterQueryString) {
      history.push(`payments${filterQueryString}`);
      getList(1, {}, filterQueryString);
    } else {
      getList();
    }
  }

  function unformat(value) {
    if (typeof value === 'number') {
      return;
    }
    let maskCurrency = IMask.createMask(mask);
    maskCurrency.resolve(value);
    var valueUnformated = maskCurrency.unmaskedValue;
    return valueUnformated;
  }

  var mask = {
    mask: Number,
    scale: 2,  // digits after point, 0 for integers
    signed: true,  // disallow negative
    thousandsSeparator: ',',  // any single char
    padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
    normalizeZeros: false,  // appends or removes zeros at ends
    radix: '.',  // fractional delimiter
    min: 0,
  };

  function getList(page = 1, sort = {}, filterQueryString = '?', clearSelectedItems = false) {
    loading.start();
    let url = `${filterQueryString}&sortBy=${JSON.stringify(sort)}&page=${page}`;

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetPaymentList(url)
      .then(response => response.json())
      .then(responseData => {
        if (responseData.ret_code !== 200) {
          mc.error(responseData.ret_msg_details);
          loading.stop();
          return;
        }

        const newData = []

        if (page === 1) {
          newData.push(...responseData.ret_value);
        } else {
          newData.push(...data, ...responseData.ret_value);
        }

        setData(newData.map((v, index) => ({
          ...v,
          amountDescription: `${v.amount.currency} ${v.amount.amount}`,
          highlightPayment: clearSelectedItems ? false : selectedPaymentsIndex.includes(index)
        })));
        setTotalPages(responseData.pagination_control.totalPages);
        setOffices(responseData.offices);
        setCurrencies(responseData.currencies);
        loading.stop();
      })
      .catch(() => {
        loading.stop();
      });
  }

  const handleSetFilterFromParams = () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);

      if (query.get('deal')) {
        formik.current?.setFieldValue('filter.deal', query.get('deal'))
      }

      if (query.get('client')) {
        formik.current?.setFieldValue('filter.client', query.get('client'))
      }

      if (query.get('party')) {
        formik.current?.setFieldValue('filter.party', query.get('party'))
      }

      if (query.get('products')) {
        let productsIds = query
          .get('products')
          .split(',')
          .map(item => Number(item))

        formik.current?.setFieldValue('filter.products', productsIds)
      }

      if (query.get('office')) {
        let officeIds = query
          .get('office')
          .split(',')
          .map(item => Number(item))

        formik.current?.setFieldValue('filter.office', officeIds)
      }

      if (query.get('doc')) {
        formik.current?.setFieldValue('filter.doc', query.get('doc'))
      }

      if (query.get('dueDateFrom') && query.get('dueDateTo')) {
        formik.current?.setFieldValue('filter.dueDate', {
          from: new Date(query.get('dueDateFrom')),
          to: new Date(query.get('dueDateTo')),
        })
      }

      if (query.get('identifier')) {
        formik.current?.setFieldValue('filter.identifier', query.get('identifier'))
      }

      if (query.get('status')) {
        let statusIds = query
          .get('status')
          .split(',')

        formik.current?.setFieldValue('filter.status', statusIds)
      }

      if (query.get('invoiceSentFrom') && query.get('invoiceSentTo')) {
        formik.current?.setFieldValue('filter.invoiceSent', {
          from: new Date(query.get('invoiceSentFrom')),
          to: new Date(query.get('invoiceSentTo')),
        })
      }

      if (query.get('currency')) {
        let currencyIds = query
          .get('currency')
          .split(',')

        formik.current?.setFieldValue('filter.currency', currencyIds)
      }

      if (query.get('hideAbortedTransactions')) {
        formik.current?.setFieldValue('filter.hideAbortedTransactions', true)
      }

      if (query.get('hideDirectPayment')) {
        formik.current?.setFieldValue('filter.hideDirectPayment', true)
      }

      if (query.get('hidePaidPayment')) {
        formik?.current?.setFieldValue('filter.hidePaidPayment', true)
      }
    }
  }

  const showRangeDate = () => {
    const from = formik.current?.values?.filter?.dueDate?.from ? formik.current.values.filter.dueDate.from.toLocaleDateString('en-GB') : ''
    const to = formik.current?.values?.filter?.dueDate?.to ? formik.current.values.filter.dueDate.to.toLocaleDateString('en-GB') : ''

    if (!from && !to) {
      return ''
    }

    return `${from} - ${to}`
  }

  const showRangeInvoiceSentDate = () => {
    const from = formik.current?.values?.filter?.invoiceSent?.from ? formik.current.values.filter.invoiceSent.from.toLocaleDateString('en-GB') : ''
    const to = formik.current?.values?.filter?.invoiceSent?.to ? formik.current.values.filter.invoiceSent.to.toLocaleDateString('en-GB') : ''

    if (!from && !to) {
      return ''
    }

    return `${from} - ${to}`
  }

  async function exportPayments(page = 1, sort = {}, filterQueryString = '?', bankMovements, sddReport) {
    let exportList = sessionStorage.getItem('texel-export-list-report');
    let list = [];
    if (exportList) list = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
    let verify = list.length > 0 ? list.filter(item => item.nameList == 'Payment Report') : false;
    if (!verify || verify.length == 0) {
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      const url = `${filterQueryString}&sortBy=${JSON.stringify(sort)}&page=${page}&bankMovements=${bankMovements}&sddReport=${sddReport}`;

      fitinsur.setAuthToken(authContext.token);
      const document = await fitinsur.exportPayments(url).then(x => x.json());
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      if (document.idDocument) {
        list.push({ idDocument: document.idDocument, processing: true, nameList: bankMovements ? 'Bank Movements' : sddReport ? 'SDD Report' : 'Payment Report' });
        sessionStorage.setItem('texel-export-list-report', JSON.stringify(list));
      }
    } else {
      mc.error("Please, wait payment report be downloaded.");
    }
  }


  async function exportPaymentsProjected() {
    let exportList = sessionStorage.getItem('texel-export-list-report');
    let list = [];
    if (exportList) list = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
    let verify = list.length > 0 ? list.filter(item => item.nameList == 'Payment Projected Report') : false;
    if (!verify || verify.length == 0) {
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      fitinsur.setAuthToken(authContext.token);

      const document = await fitinsur.exportPaymentsProjected().then(x => x.json());
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      if (document.idDocument) {
        list.push({ idDocument: document.idDocument, processing: true, nameList: 'Payment Projected Report' });
        sessionStorage.setItem('texel-export-list-report', JSON.stringify(list));
      }
    } else {
      mc.error("Please, wait payment projected report be downloaded.");
    }
  }

  const editCustomFilter = (filter) => {
    if (!filter.filter.name) {
      mc.error("Please provide a name");
      return;
    }
    const obj = {
      filterName: filter.filter.name,
      id: filter.filter.id,
      idDomain: 321,
      idDomainApplication: 388,
      filterArgs: {
        deal: filter.filter.deal,
        office: filter.filter.office,
        products: filter.filter.products,
        client: filter.filter.client,
        doc: filter.filter.doc,
        party: filter.filter.party,
        currency: filter.filter.currency,
        dueDate: {
          from: filter.filter.dueDate.from,
          to: filter.filter.dueDate.to,
        },
        status: filter.filter.status,
        identifier: filter.filter.identifier,
        invoiceSent: {
          from: filter.filter.invoiceSent.from,
          to: filter.filter.invoiceSent.to,
        },
        hideAbortedTransactions: filter.filter.hideAbortedTransactions,
        hideDirectPayment: filter.filter.hideDirectPayment,
        hidePaidPayment: filter.filter.hidePaidPayment
      }
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        mc.success("Filter updated successfully");
        setIsAbleEdit(!isAbleEdit)
        requestCustomFilterList('edit')
      })
  }

  const createCustomFilter = (filter) => {
    if (!filter.filter.name) {
      mc.error("Please provide a name");
      return;
    }
    const obj = {
      filterName: filter.name,
      idDomain: 321,
      idDomainApplication: 388,
      filterArgs: {
        deal: filter.filter.deal,
        office: filter.filter.office,
        products: filter.filter.products,
        client: filter.filter.client,
        doc: filter.filter.doc,
        party: filter.filter.party,
        currency: filter.filter.currency,
        dueDate: {
          from: filter.filter.dueDate.from,
          to: filter.filter.dueDate.to,
        },
        status: filter.filter.status,
        identifier: filter.filter.identifier,
        invoiceSent: {
          from: filter.filter.invoiceSent.from,
          to: filter.filter.invoiceSent.to,
        },
        hideAbortedTransactions: filter.filter.hideAbortedTransactions,
        hideDirectPayment: filter.filter.hideDirectPayment,
        hidePaidPayment: filter.filter.hidePaidPayment
      }
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestCreateCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        mc.success("Filter created successfully.");
        setIsAbleCreate(!isAbleCreate)
        requestCustomFilterList('create')
      })
  }

  const deleteCustomFilter = (selectedFilter) => {
    if (selectedFilter.filterName !== 'DEFAULT') {
      const obj = {
        filterName: selectedFilter.filterName,
        id: selectedFilter.id,
        idDomain: selectedFilter.idDomain,
        idDomainApplication: selectedFilter.idDomainApplication,
      }
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestDeleteCustomFilter(obj)
        .then(x => x.json())
        .then(res => {
          if (res.ret_code !== 200) {
            mc.error("An error happened, please try again.");
            return;
          }
          mc.success('successfully deleted filter')
          setShowFilter(false)
          setIsAbleDelete(false)
          requestCustomFilterList('delete')
        })
    } else {
      mc.error("This filter cannot be removed!")
    }
  }

  const requestCustomFilterList = (action) => {

    const obj = {
      idDomain: 321,
      idDomainApplication: 388
    }

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        const enquiryFilterList = res.ret_value.filter(
          element => {
            return element.idDomain === 321 && element.idDomainApplication === 388
          }
        )
        const option = []
        enquiryFilterList.map((element, index) => {
          let opt = {
            label: element.filterName,
            value: index
          }
          option.push(opt)
        })
        setFilterOptions(option)
        setFiltersList(enquiryFilterList)

        const query = new URLSearchParams(location.search);
        let name = query.get('name')
        let index = option.find(option => option.label === name)?.value
        if (action === 'search' || action === 'load' || name) {
          formik.current?.setFieldValue("filtersList", index);
          const value = {
            id: "",
            filterName: name,
            deal: "",
            office: "",
            client: "",
            doc: "",
            party: "",
            currency: "",
            dueDate: {
              from: null,
              to: null,
            },
            status: "",
            identifier: "",
            invoiceSent: {
              from: null,
              to: null,
            },
            hideAbortedTransactions: false,
            hideDirectPayment: false,
            hidePaidPayment: false,
          };
          setFilterSelected(value)
        } if (action === 'create') {
          const filterCreated = option[option.length - 1]
          formik.current?.setFieldValue("filtersList", filterCreated.value);
          const value = {
            id: "",
            filterName: filterCreated.label,
            deal: "",
            office: "",
            client: "",
            doc: "",
            party: "",
            currency: "",
            dueDate: {
              from: null,
              to: null,
            },
            status: "",
            identifier: "",
            invoiceSent: {
              from: null,
              to: null,
            },
            hideAbortedTransactions: false,
            hideDirectPayment: false,
            hidePaidPayment: false
          };
          setFilterSelected(value)
        } if (action === 'load' && !name || action === 'reset') {
          setFilterSelected(enquiryFilterList[0])
          formik.current?.setFieldValue("filtersList", 0);
        }
      })
  }

  const controlFilter = (action) => {
    if (action === 'edit' && filterSelected.filterName && filterSelected.filterName != 'DEFAULT') {
      setIsAbleEdit(!isAbleEdit)
      setIsAbleDelete(false)
      setIsAbleCreate(false)
    }
    if (action === 'create') {
      setIsAbleEdit(false)
      setIsAbleDelete(false)
      setIsAbleCreate(!isAbleCreate)
      setFilterSelected(initialValues)
    }
    if (action === 'delete') {
      if (filterSelected.filterName === 'DEFAULT') return;
      deleteFilter()
    }
  }

  useEffect(() => {
    getMasks();
    requestProductsList();
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      goToLoginPage();
    } else {
      fitinsur.setAuthToken(authContext.token);
    }

    formik.current?.setFieldValue("payments", data);

    if (location.search) {
      handleSetFilterFromParams();
      getList(1, {}, location.search);
    } else {
      handleGetPreviusFilter();
    }
    requestCustomFilterList('load');

    cache.getTooltip("DOMAINS", region, "357", [585, 586, 588, 587, 593], authContext.token).then(msg => {
      let obj = [];
      msg.map(element => {
        obj[element.MODEL_ITEM_ID] = element.MSG_TEXT;
      })
      setTooltips(obj)
    }).catch(err => console.log("error", err));
  }, []);

  useEffect(() => {
    formik.current?.setFieldValue("payments", data);
  }, [data]);

  useEffect(() => {
    handleHighlightPayment(selectedPaymentsIndex);
  }, [selectedPaymentsIndex]);

  const handleGettingPaymentInformation = () => {
    let options = [];
    const payments = selectedPaymentsIndex.map(index => (
      formik.current.values.payments[index]
    ));
    if (payments.find(payment => payment.status.label === 'Aborted')) {
      options = [
        { label: 'Created', value: 'created' },
        { label: 'Aborted', value: 'aborted' }
      ];
    } else {
      options = [
        { label: 'Created', value: 'created' },
        { label: 'Awaiting Payment', value: 'awaiting_payment' },
        { label: 'Paid', value: 'paid' },
        { label: 'Sent to XIS', value: 'loaded' },
        { label: 'Signed', value: 'assigned' },
        { label: 'Aborted', value: 'aborted' }
      ];
    }
    setModalOptions(options)
    setSelectedPaymentsUpdate(payments);
    setModal(true);
  }

  const getMasks = async () => {
    const t = await maskHelper.getMaskConfigs([69, 70], 295, authContext.token);
    setMasks(t);
  };

  const handlePaymentSelectionToUpdateStatus = (index, e) => {
    const payment = formik.current.values.payments[index];
    let trueFalse = !selectedPaymentsIndex.includes(index);

    if (
      selectedPaymentsIndex.length >= 50 ||
      (!props.permissions.PAYMENTS_CHANGE_ABORTED && payment.status.label === "Aborted") ||
      (
        payment.status.label === 'Paid' ||
        payment.status.label === 'Direct Payment'
      ) ||
      (dealGroup && dealGroup !== payment.idOperation)
    ) return

    let sum = sumAmount;
    if (trueFalse) {
      if (payment.amount.amountType == "C") {
        sum += parseFloat(unformat(payment.amount.amount))

      } else if (payment.amount.amountType == "D") {
        sum -= parseFloat(unformat(payment.amount.amount))

      }
    } else {
      if (payment.amount.amountType == "C") {
        sum -= parseFloat(unformat(payment.amount.amount))

      } else if (payment.amount.amountType == "D") {
        sum += parseFloat(unformat(payment.amount.amount))
      }
    }
    sum = parseFloat(sum.toFixed(2))
    setSumAmount(sum)

    if (!selectedPaymentsIndex.length)
      setDealGroup(payment.idOperation);

    const alreadySelected = selectedPaymentsIndex.findIndex(payment => payment === index);

    if (alreadySelected > -1) {
      const filteredPayment = selectedPaymentsIndex.filter(payment => payment !== index);

      if (!filteredPayment.length) {
        setDealGroup(null);
        setSumAmount(0)
      }

      setSelectedPaymentsIndex(filteredPayment);
    } else {
      setSelectedPaymentsIndex([...selectedPaymentsIndex, index]);
    }
  }

  const handleCustomFilter = (value) => {
    if (isAbleEdit) {
      if (!value.filter.name || value.filter.name === 'DEFAULT' || value.filter.name === 'default') {
        return mc.error("An error happened, incorrect value for filter name.");
      }
      setIsAbleEdit(false)
      return editCustomFilter(value)
    }
    if (isAbleCreate) {
      if (!value.filter.name || value.filter.name === 'DEFAULT' || value.filter.name === 'default') {
        return mc.error("An error happened, incorrect value for filter name.");
      }
      setIsAbleCreate(false)
      return createCustomFilter(value)
    }
    if (!isAbleCreate || !isAbleEdit) {
      setShowFilter(false)
      return handleFilter(value)
    }
  };

  useEffect(() => {
    if (scrollUpdate && scrollUpdateMode && !(!data || data.length === 0 || pageNumber === totalPages)) {
      if (!loading.active) {
        nextPage();
      }
    }
  }, [scrollUpdate])

  useEffect(() => {
    console.debug('The new value of scrollUpdateMode is:', scrollUpdateMode);
  }, [scrollUpdateMode]);

  return (
    <Layout title={'Payments'}>
      <DialogComponent
        icon={dialog.icon}
        title={dialog.title}

        show={dialog.visible}
        setDialog={setDialog}
      >
        {typeDialog === 'deleteFilter'
          ? (
            <>
              <DialogCancel onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setDialog({ visible: false, title: null, icon: null, args: null })
              }}>
                Cancel
              </DialogCancel>
              <DialogConfirm onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                deleteCustomFilter(filterSelected);
                setFilterSelected(filtersList[0])
                setDialog({ visible: false, title: null, icon: null, args: null })
              }}>
                Confirm
              </DialogConfirm>
            </>
          ) : typeDialog === 'changeStatus' ?
            (
              <>
                <ContentTextarea>
                  <p>Confirm change?</p>
                </ContentTextarea>
                <DialogCancel
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (!dialog.args) return;
                    return handleStatus(dialog.args.index, "cancel");
                  }}
                >
                  Cancel
                </DialogCancel>
                <DialogConfirm
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (!dialog.args) return;
                    return handleStatus(dialog.args.index, "confirm");
                  }}
                >
                  Confirm
                </DialogConfirm>
              </>
            ) : null}
      </DialogComponent>

      <Content>
        <NotesModal
          show={showPaymentNotesModal}
          handleClose={() => setShowPaymentNotesModal(false)}
          onSubmit={(notes) => handleSubmitNotes(notesModalProps?.item, notes)}
          notesHistory={notesModalProps?.notes}
        />
        <Formik
          initialValues={initialValues}
          onSubmit={values => handleCustomFilter(values)}
          innerRef={formik}
        >
          {(formikProps) => {

            return (
              <Form style={{ minHeight: showFilter || showExport ? '550px' : '' }}>
                <RowFilterIcon>
                  {selectedPaymentsIndex.length ? (
                    <Col style={{ display: 'inline-flex', minWidth: '165px', alignItems: 'center' }}>
                      <Counter>{selectedPaymentsIndex.length ? `SELECTED (${selectedPaymentsIndex.length}/50)` : ''}</Counter>
                    </Col>
                  ) : null}

                  <Col style={{ display: 'flex', minWidth: '360px', alignItems: 'center' }}>
                    <CounterAmount>
                      TOTAL AMOUNT SELECTED: {sumAmount == 0 ? "0.00" : maskHelper.resolveMask(sumAmount, maskHelper.getMaskConfig(masks, 69, authContext.region, null, true))}
                    </CounterAmount>
                  </Col>


                  <FilterContainer className={showFilter ? 'filter-open close' : 'filter-close'}>
                    <Row>
                      <Col style={{ display: "flex", justifyContent: 'flex-end' }}>
                        <Icon name="close" className="icon-close" onClick={() => setShowFilter(false)} />
                      </Col>
                    </Row>

                    <RowFilterOrder>
                      <MobileLabel>
                        ORDER
                      </MobileLabel>
                      <div style={{ display: "flex", flexDirection: "column", padding: "10px" }}>
                        {showFilter && columnsFilter.map((column, index) =>
                          <Row key={index}>
                            <GridColumnTitle
                              onClick={() => column.value && handleSortList(column.value)}
                              style={{ cursor: column.value ? 'pointer' : 'not-allowed' }}
                              className="mb-2 mr-2"
                            >
                              {column.title}
                            </GridColumnTitle>
                            {column.value && sortBy.key === column.value && sortBy.direction === "asc" ?
                              <Icon name={"arrowup"} /> :
                              column.value && sortBy.key === column.value && sortBy.direction === "desc" ?
                                <Icon name={"arrowdown"} /> :
                                ''}
                          </Row>
                        )}
                      </div>
                    </RowFilterOrder>
                    <hr className="d-md-none mb-3" />
                    <FilterSearchContainer>
                      <Row>
                        <Col>
                          <MobileLabel>
                            {filterSelected.filterName ? filterSelected.filterName : 'FILTER'}
                          </MobileLabel>
                        </Col>
                        <Col>
                          <Row>
                            <ColIcon>
                              <Icon
                                name="edit"
                                onClick={() => {
                                  controlFilter('edit')
                                }}
                                disabled={true}
                              />
                            </ColIcon>
                            <ColIcon>
                              <Icon
                                name="trash"
                                onClick={() => {
                                  formikProps.setValues({
                                    filter: {
                                      id: '',
                                      name: '',
                                      deal: '',
                                      office: '',
                                      client: '',
                                      doc: '',
                                      party: '',
                                      currency: '',
                                      dueDate: {
                                        from: '',
                                        to: '',
                                      },
                                      status: '',
                                      identifier: '',
                                      invoiceSent: {
                                        from: '',
                                        to: '',
                                      },
                                      hideAbortedTransactions: '',
                                      hideDirectPayment: '',
                                      hidePaidPayment: ''
                                    }
                                  })
                                  controlFilter('delete')
                                }}
                              />
                            </ColIcon>
                            <ColIcon>
                              <Icon
                                name="add-grey"
                                onClick={() => {
                                  formikProps.setValues({
                                    filter: {
                                      id: '',
                                      name: '',
                                      deal: '',
                                      office: '',
                                      client: '',
                                      doc: '',
                                      party: '',
                                      currency: '',
                                      dueDate: {
                                        from: '',
                                        to: '',
                                      },
                                      status: '',
                                      identifier: '',
                                      invoiceSent: {
                                        from: '',
                                        to: '',
                                      },
                                      hideAbortedTransactions: '',
                                      hideDirectPayment: '',
                                      hidePaidPayment: ''
                                    }
                                  })
                                  controlFilter('create')
                                }}
                              />
                            </ColIcon>
                          </Row>

                        </Col>
                      </Row>
                      <RowFilter>
                        {isAbleEdit || isAbleCreate ?
                          <FilterColumn>
                            <Field
                              name="filter.name"
                              placeholder="Filter Name"
                              value={formikProps.values.filter.name}
                              component={InputField}
                              type="text"
                              onChange={(e) => {
                                formikProps?.setFieldValue("name", e);
                              }}
                              validation={false}
                              list={true}
                            />
                          </FilterColumn>
                          :
                          <FilterColumn>
                            <Field
                              name="filtersList"
                              label="My filters"
                              isRequired
                              options={filterOptions}
                              onChange={(e) => {
                                setFilterSelected(filtersList[e])
                                formikProps.setValues({
                                  filter: {
                                    id: filtersList[e].id,
                                    name: filtersList[e].filterName,
                                    deal: filtersList[e].filterArgs.deal,
                                    office: filtersList[e].filterArgs.office,
                                    client: filtersList[e].filterArgs.client,
                                    doc: filtersList[e].filterArgs.doc,
                                    party: filtersList[e].filterArgs.party,
                                    currency: filtersList[e].filterArgs.currency,
                                    dueDate: {
                                      from: filtersList[e].filterArgs.dueDate.from,
                                      to: filtersList[e].filterArgs.dueDate.to,
                                    },
                                    status: filtersList[e].filterArgs.status,
                                    identifier: filtersList[e].filterArgs.identifier,
                                    invoiceSent: {
                                      from: filtersList[e].filterArgs.invoiceSent.from,
                                      to: filtersList[e].filterArgs.invoiceSent.to,
                                    },
                                    hideAbortedTransactions: filtersList[e].filterArgs.hideAbortedTransactions,
                                    hideDirectPayment: filtersList[e].filterArgs.hideDirectPayment,
                                    hidePaidPayment: filtersList[e].filterArgs.hidePaidPayment
                                  }
                                })
                                formikProps?.setFieldValue("filtersList", filterOptions[e].value);
                              }}
                              component={SelectField}
                            />
                          </FilterColumn>
                        }
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.deal.length}
                              onChange={() => formik.current?.setFieldValue('filter.deal', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.deal'
                            placeholder='Deal'
                            component={InputField}
                            validation={false}
                            onPressEnter={() => handleCustomFilter(formikProps?.values)}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.client.length}
                              onChange={() => formik.current?.setFieldValue('filter.client', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.client'
                            placeholder='Client'
                            component={InputField}
                            validation={false}
                            onPressEnter={() => handleCustomFilter(formikProps?.values)}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.party.length}
                              onChange={() => formik.current?.setFieldValue('filter.party', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.party'
                            placeholder='Main Party'
                            component={InputField}
                            validation={false}
                            onPressEnter={() => handleCustomFilter(formikProps?.values)}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.products?.length}
                              onChange={() => formik.current?.setFieldValue('filter.products', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.products'
                            placeholder='products'
                            component={MultiSelectField}
                            options={products}
                            validation={false}
                            format={(value) => {
                              const selectedProducts = products.filter(option => value.includes(option.value))
                              return selectedProducts.map(item => item.label).join(', ')
                            }}
                            onChange={(e) => {
                              if (!e.length) {
                                formik.current?.setFieldValue(
                                  "filter.products",
                                  ""
                                )
                              } else {
                                formik.current?.setFieldValue(
                                  "filter.products",
                                  e
                                )
                              }
                            }}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.office.length}
                              onChange={() => formik.current?.setFieldValue('filter.office', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.office'
                            placeholder='Office'
                            component={MultiSelectField}
                            options={offices}
                            validation={false}
                            format={(value) => {
                              const selectedOffices = offices.filter(option => value.includes(option.value))
                              return selectedOffices.map(item => item.label).join(', ')
                            }}
                            onChange={(e) => {
                              if (!e.length) {
                                formik.current?.setFieldValue(
                                  "filter.office",
                                  ""
                                )
                              } else {
                                formik.current?.setFieldValue(
                                  "filter.office",
                                  e
                                )
                              }
                            }}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.doc.length}
                              onChange={() => formik.current?.setFieldValue('filter.doc', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.doc'
                            placeholder='Doc'
                            component={InputField}
                            validation={false}
                            onPressEnter={() => handleCustomFilter(formikProps?.values)}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.currency.length}
                              onChange={() => formik.current?.setFieldValue('filter.currency', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.currency'
                            placeholder='Currency'
                            component={MultiSelectField}
                            options={currencies}
                            validation={false}
                            format={(value) => {
                              const selectedCurrencies = currencies.filter(option => value.includes(option.value))
                              return selectedCurrencies.map(item => item.label).join(', ')
                            }}
                            onChange={(e) => {
                              if (!e.length) {
                                formik.current?.setFieldValue(
                                  "filter.currency",
                                  ""
                                )
                              } else {
                                formik.current?.setFieldValue(
                                  "filter.currency",
                                  e
                                )
                              }
                            }}

                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.dueDate.from}
                              onChange={() => formik.current?.setFieldValue('filter.dueDate', { from: null, to: null })}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.dueDate'
                            placeholder='Due date'
                            component={InputField}
                            rightIcon='calendar'
                            rightIconClick={() => { setShowCalendar(!showCalendar) }}
                            validation={false}
                            customValue={showRangeDate()}
                            type="text"
                            readOnly
                          />
                        </FilterColumn>
                      </RowFilter>
                      {showCalendar &&
                        <CalendarContainer>
                          <DateRangePicker
                            initialRange={{
                              from: formikProps.values?.filter?.dueDate?.from,
                              to: formikProps.values?.filter?.dueDate?.to,
                            }}
                            onChange={range => {
                              formikProps?.setFieldValue('filter.dueDate.from', range.from)
                              formikProps?.setFieldValue('filter.dueDate.to', range.to)

                              if (range.from && range.to) {
                                setShowCalendar(false)
                                handleFilter({
                                  dueDateFrom: new Date(range.from).toLocaleDateString('en-US'),
                                  dueDateTo: new Date(range.to).toLocaleDateString('en-US'),
                                })
                              }

                            }}
                          />
                        </CalendarContainer>
                      }
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.identifier.length}
                              onChange={() => formik.current?.setFieldValue('filter.identifier', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.identifier'
                            placeholder='Identifier'
                            component={InputField}
                            validation={false}
                            onPressEnter={() => handleCustomFilter(formikProps?.values)}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.invoiceSent.from}
                              onChange={() => formik.current?.setFieldValue('filter.invoiceSent', { from: null, to: null })}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.invoiceSent'
                            placeholder='Invoice Sent'
                            component={InputField}
                            rightIcon='calendar'
                            rightIconClick={() => { setShowInvoiceSentCalendar(!showInvoiceSentCalendar) }}
                            validation={false}
                            customValue={showRangeInvoiceSentDate()}
                            type="text"
                            readOnly
                          />
                        </FilterColumn>
                      </RowFilter>
                      {showInvoiceSentCalendar &&
                        <CalendarContainer>
                          <DateRangePicker
                            initialRange={{
                              from: formikProps.values?.filter?.invoiceSent?.from,
                              to: formikProps.values?.filter?.invoiceSent?.to,
                            }}
                            onChange={range => {
                              formikProps?.setFieldValue('filter.invoiceSent.from', range.from)
                              formikProps?.setFieldValue('filter.invoiceSent.to', range.to)

                              if (range.from && range.to) {
                                setShowInvoiceSentCalendar(false)
                                handleFilter({
                                  invoiceSentFrom: new Date(range.from).toLocaleDateString('en-US'),
                                  invoiceSentTo: new Date(range.to).toLocaleDateString('en-US'),
                                })
                              }

                            }}
                          />
                        </CalendarContainer>
                      }
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.status.length}
                              onChange={() => formik.current?.setFieldValue('filter.status', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name='filter.status'
                            placeholder='Status'
                            component={MultiSelectField}
                            options={getStatusFilter}
                            validation={false}
                            format={(value) => {
                              const statusCMonths = getStatusFilter.filter(option => value.includes(option.value))
                              return statusCMonths.map(item => item.label).join(', ')
                            }}
                            onChange={(e) => {
                              if (!e.length) {
                                formik.current?.setFieldValue(
                                  "filter.status",
                                  ""
                                )
                              } else {
                                formik.current?.setFieldValue(
                                  "filter.status",
                                  e
                                )
                              }
                            }}
                          />
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.hideAbortedTransactions}
                              onChange={() => formik.current?.setFieldValue('filter.hideAbortedTransactions', !formikProps.values.filter.hideAbortedTransactions)}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn style={{ paddingLeft: "10px" }}>
                          <Label>Hide Aborted Transactions</Label>
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.hideDirectPayment}
                              onChange={() => formik.current?.setFieldValue('filter.hideDirectPayment', !formikProps.values.filter.hideDirectPayment)}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn style={{ paddingLeft: "10px" }}>
                          <Label>Hide Direct Payment's</Label>
                        </FilterColumn>
                      </RowFilter>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.hidePaidPayment}
                              onChange={() => formik?.current?.setFieldValue('filter.hidePaidPayment', !formikProps.values.filter.hidePaidPayment)}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn style={{ paddingLeft: "10px" }}>
                          <Label>Hide Paid Transactions</Label>
                        </FilterColumn>
                      </RowFilter>
                    </FilterSearchContainer>

                    <Row align="center" className='apply-button-container'>
                      <Col>
                        <Button
                          primary
                          type="submit"
                          id="btnFilter"
                          style={{ textAlign: "center" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleCustomFilter(formikProps.values);
                          }}
                        >
                          {isAbleEdit || isAbleCreate ? 'Save' : 'Apply'}
                        </Button>
                      </Col>
                    </Row>
                  </FilterContainer>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                    <FilterLabel style={{ margin: 0 }}>
                      {filterSelected.filterName ? `FILTER: ${filterSelected.filterName}` : ''}
                    </FilterLabel>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <HasPermission permission={props.permissions.PAYMENTS_IMPORT_OSND}>
                        <div style={{ marginLeft: 10, marginRight: 10 }}>
                          <ButtonImportOSND />
                        </div>
                      </HasPermission>

                      <MultipleExport
                        permissions={props.permissions}
                        showExport={showExport}
                        setShowExport={setShowExport}
                        onExportReport={(reportName) => {
                          setShowExport(false);
                          if (reportName === "payments") return exportPayments(1, sortBy, location.search || undefined, false, false);
                          if (reportName === "bankMovements") return exportPayments(1, sortBy, location.search || undefined, true, false);
                          if (reportName === "sddReport") return exportPayments(1, sortBy, location.search || undefined, false, true);
                          if (reportName === "projectReport1") return exportPayments(1, sortBy, "?showFutureDeals=true" || undefined);
                          if (reportName === "projectReport2") return exportPaymentsProjected();
                        }}
                      />
                      <TooltipCard>
                        <TooltipText>
                          <ColIcon>
                            <Icon name="filter" onClick={() => setShowFilter(!showFilter)} />
                          </ColIcon>
                        </TooltipText>
                        <TooltipBox>
                          {tooltips[585]}
                        </TooltipBox>
                      </TooltipCard>
                      <TooltipCard>
                        <TooltipText>
                          <ColIcon>
                            <Icon name="filterCan" onClick={(e) => { resetFilters() }} />
                          </ColIcon>
                        </TooltipText>
                        <TooltipBox>
                          {tooltips[586]}
                        </TooltipBox>
                      </TooltipCard>
                    </div>
                  </div>
                </RowFilterIcon>

                <div style={{ marginLeft: 15, marginRight: 15 }}>
                  <ResponsiveTable formikRef={formik?.current} columns={columns} data={data} />
                </div>

              </Form>
            )
          }}
        </Formik>
        <LoadContainer>
          {(!data || data.length === 0 || pageNumber === totalPages) ?
            <Button forth onClick={(e) => e.preventDefault()}>
              NO MORE ITEMS
            </Button> :
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <Button forth onClick={() => nextPage()}>
                +LOAD MORE ACCOUNTS
              </Button>
              <Label>
                <Checkbox2
                  checked={scrollUpdateMode}
                  onClick={(e) => setTimeout((e) => setScrollUpdateMode(!scrollUpdateMode), 0)}
                />&nbsp;AUTO-FEED MODE
              </Label>
            </div>
          }
          <HasPermission permission={props.permissions.PAYMENTS_CHANGE_STATUS && selectedPaymentsIndex.length}>
            <Button
              type="button"
              primary={true}
              onClick={() => handleGettingPaymentInformation()}
              disabled={!selectedPaymentsIndex.length}
            >
              UPDATE
            </Button>
          </HasPermission>
        </LoadContainer>
      </Content>
      <BulkPaymentUpdate
        showModal={modal}
        onClose={() => setModal(false)}
        onUpdated={() => getList(1, {}, location.search)}
        selectedPayments={selectedPaymentsUpdate}
        statusOptions={modalOptions}
        props={props}
        handleResettingPaymentSelection={handleResettingPaymentSelection}
      />
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </Layout>
  );
}
